import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  MinusCircleOutlined,
  WarningOutlined,
} from '@ant-design/icons'
import { OverallTestsRunReport } from '@signifyd/cypress'

export const BUCKET_NAME = 'fe-playwright-results-bucket'
export const FETCH_FILENAME_DATA_KEY = 'awsS3'

export type EnhancedOverallTestsRunReport = OverallTestsRunReport & {
  filename: string
  projectName: string
}

export const statusTag = {
  timedOut: { icon: <CloseCircleOutlined />, color: 'red' },
  passed: { icon: <CheckCircleOutlined />, color: 'green' },
  failed: { icon: <CloseCircleOutlined />, color: 'red' },
  skipped: { icon: <MinusCircleOutlined />, color: 'blue' },
  flaky: { icon: <WarningOutlined />, color: 'yellow' },
  interrupted: { icon: <MinusCircleOutlined />, color: 'grey' },
}
